const videos = [
  {
    type: "video",
    width: 1280,
    height: 720,
    poster:
      "https://res.cloudinary.com/dcbw508s1/image/upload/v1669286177/videos/iwd_atcrsn.jpg",
    sources: [
      {
        src: "https://res.cloudinary.com/dcbw508s1/video/upload/v1669284616/videos/An_Equal_Future_for_Women_ChooseToChallengeIn_response_to_the_SDG_5_achieving_gender_equality_and_empowering_all_women_we_are_pleased_to_inform_you_that_Computer_Science_Society_is_collaborating_with_the_Centre_sva8ku.mp4",
        type: "video/mp4",
      },
    ],
  },
  {
    type: "video",
    width: 1280,
    height: 720,
    poster:
      "https://res.cloudinary.com/dcbw508s1/image/upload/v1669286177/videos/ssicomm_y9krjt.jpg",
    sources: [
      {
        src: "https://res.cloudinary.com/dcbw508s1/video/upload/v1669285256/videos/SSI_Committee_Video_Academic_Session_20_21_taii0l.mp4",
        type: "video/mp4",
      },
    ],
  },
  {
    type: "video",
    width: 1280,
    height: 720,
    poster:
      "https://res.cloudinary.com/dcbw508s1/image/upload/v1669286260/videos/signoff_mdgpld.jpg",
    sources: [
      {
        src: "https://res.cloudinary.com/dcbw508s1/video/upload/v1669285256/videos/SSI_COMMITTEE_20_21_SIGN_OFF_g9vzme.mp4",
        type: "video/mp4",
      },
    ],
  },
  {
    type: "video",
    width: 1280,
    height: 720,
    poster:
      "https://res.cloudinary.com/dcbw508s1/image/upload/v1669286177/videos/projectusm_tosrra.jpg",
    sources: [
      {
        src: "https://res.cloudinary.com/dcbw508s1/video/upload/v1669285255/videos/PROJECT_USM_UPLIFT_STUDENT_S_MOTIVE_t1kuny.mp4",
        type: "video/mp4",
      },
    ],
  },
  {
    type: "video",
    width: 1280,
    height: 720,
    poster:
      "https://res.cloudinary.com/dcbw508s1/image/upload/v1669286177/videos/freshies_pte2gl.jpg",
    sources: [
      {
        src: "https://res.cloudinary.com/dcbw508s1/video/upload/v1669285262/videos/Freshies_Welcoming_Speech_by_President_szkhe8.mp4",
        type: "video/mp4",
      },
    ],
  },
];

export default videos;
